import store from '@/store'
import actions from '@/store/actions'

export const generateReport = async (contractId, body) => {
  const report = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/reports`,
      method: 'POST',
      body
    }
  )
  return report
}

export const updateReport = async (contractId, reportId, body) => {
  const report = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/reports/${reportId}`,
      method: 'PUT',
      body
    }
  )
  return report
}

export const deleteReport = async (contractId, reportId) => {
  const report = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/reports/${reportId}`,
      method: 'DELETE'
    }
  )
  return report
}

export const getReports = async (contractId) => {
  const reports = await store.dispatch(
    actions.callApi,
    {
      url: `contracts/${contractId}/reports`,
      method: 'GET'
    }
  )
  return reports
}
